<template>
    <div class="contentSelection" v-if="dataItem && dataItem.length > 0">
        <!--1好课  4直播 6病例实战  9指南共识 13专题 30医学专栏，31学术会议 -->
        <div v-for="(item, index) in dataItem" :key="index">
            <Course v-if="item.origin_type === 1" :dataItem="item"/>
            <Lives v-if="item.origin_type === 4" :dataItem="item" />
            <Case v-else-if="item.origin_type === 6" :dataItem="item" />
            <Guide v-else-if="item.origin_type === 9" :data-item="item"/>
            <Special v-else-if="item.origin_type === 13" :dataItem="item" />
            <Medicine v-else-if="item.origin_type === 30" :dataItem="item" :posType="posType"/>
            <Academic v-else-if="item.origin_type === 31" :dataItem="item" />
        </div>
    </div>
</template>

<script>
import {
    Course,
    Lives,
    Case,
    Guide,
    Special,
    Medicine,
    Academic
} from './index.js'

export default {
    name: 'contentSelection',
    components: {
        Course,
        Case,
        Guide,
        Medicine,
        Lives,
        Academic,
        Special,
    },
    props: {
        dataItem: {
            type: Array,
            default: () => [],
            required: true
        },
        posType: {
          type: Number,
          default: 0
        }
    },
    methods: {
      tabClick() {
        console.log('父组件======')
        console.log('====',this.$parent)
        this.$parent.$parent.tabClick()
      },
      fresh() {
        console.log('首页 父组件======')
        console.log('====',this.$parent)
        this.$parent.$parent.freshList()
      }
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/contentSelection/index.vue